module.exports = __webpack_public_path__ + "static/media/jardinero.4a4933ac.png";